import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import StripeModeBadge from "./components/StripeModeBadge";
import LandingPage from "./pages/LandingPage";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import RegistrationSuccess from "./pages/RegistrationSuccess";
import WelcomeEric from "./pages/WelcomeEric";
import WelcomeNeil from "./pages/WelcomeNeil";
import SpeakerAdamHarte from "./pages/SpeakerAdamHarte";
import WelcomeDeWayne from "./pages/WelcomeDeWayne";
import WelcomeDavidG from "./pages/WelcomeDavidG";
import WelcomeDavidH from "./pages/WelcomeDavidH";
import AgendaPage from "./pages/AgendaPage";
import SurveyPage from "./pages/SurveyPage";
import AdminSurveys from "./pages/AdminSurveys";
import FeedbackPage from "./pages/FeedbackPage";
import AdminFeedback from "./pages/AdminFeedback";
import AdminWaitlist from "./pages/AdminWaitlist";
import AdminHome from "./pages/AdminHome";
import PromoPage from "./pages/PromoPage";
import PortalHome from "./pages/PortalHome";
import {
  PortalReset2027,
  PortalMonthlyMeeting,
  PortalMeditation,
  PortalCoaching,
  PortalResources,
  PortalCommunity,
  PortalHealth,
  PortalFinancial,
  PortalPillars,
  PortalReflection,
} from "./pages/PortalPages";
import { MonthlyCircleRegister, MonthlyCircleSuccess } from "./pages/MonthlyCirclePages";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StripeModeBadge />
        <Routes>
          <Route path="/" element={<Navigate to="/portal" replace />} />
          <Route path="/retreat-2026" element={<LandingPage />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/registration-success" element={<RegistrationSuccess />} />
          <Route path="/welcome/eric" element={<WelcomeEric />} />
          <Route path="/welcome/neil" element={<WelcomeNeil />} />
          <Route path="/speakers/adam-harte" element={<SpeakerAdamHarte />} />
          <Route path="/welcome/dewayne" element={<WelcomeDeWayne />} />
          <Route path="/welcome/david" element={<WelcomeDavidG />} />
          <Route path="/welcome/david-girton" element={<WelcomeDavidG />} />
          <Route path="/welcome/david-harper" element={<WelcomeDavidH />} />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/admin/surveys" element={<AdminSurveys />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/admin/feedback" element={<AdminFeedback />} />
          <Route path="/admin/waitlist" element={<AdminWaitlist />} />
          <Route path="/admin" element={<AdminHome />} />
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/portal" element={<PortalHome />} />
          <Route path="/portal/reset-2027" element={<PortalReset2027 />} />
          <Route path="/portal/monthly-meeting" element={<PortalMonthlyMeeting />} />
          <Route path="/portal/monthly-meeting/register" element={<MonthlyCircleRegister />} />
          <Route path="/portal/monthly-meeting/success" element={<MonthlyCircleSuccess />} />
          <Route path="/portal/meditation" element={<PortalMeditation />} />
          <Route path="/portal/coaching" element={<PortalCoaching />} />
          <Route path="/portal/resources" element={<PortalResources />} />
          <Route path="/portal/community" element={<PortalCommunity />} />
          <Route path="/portal/health-wellness" element={<PortalHealth />} />
          <Route path="/portal/financial-wellness" element={<PortalFinancial />} />
          <Route path="/portal/pillars" element={<PortalPillars />} />
          <Route path="/portal/reflection" element={<PortalReflection />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
